import { useContext, useEffect, useState } from "react";
import { RecruitmentContext } from "./Recruitment_From";
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid } from "@mui/material";
import { AxiosPost, SendAPIFile } from "utilities/Axios";
import { BsFillCameraFill } from "react-icons/bs";
import { CheckboxFormItem, InputNumberForm, RadioForm, SelectFormItem, SelectMultipleFormItem, TextBoxForm } from "components/Input";
import { DatePickerFromItem } from "components/Input/DatePicker";
import moment from "moment";
import { undefinedOrNull } from "utilities/Function";
import TableUI from "components/TableUI";
import { BtnAdd, BtnDeleteTable, BtnEditTable, BtnSaveIcon, BtnViewTable, BtnCancelIcon } from "components/Button";
import { ColumnProps } from "components/TableUI/TableUI";
import { CheckboxGroupFormItem } from "components/Input/Checkbox";
import { FormProvider, useForm } from "react-hook-form";
import { AiFillEdit } from "react-icons/ai";
import { FIleItem, TEducationalRecord, TLanguageAbility, TWorkHistory, TrainingHistory } from "view/Register/Component/RegisterClass";
import { List } from "linqts";
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import { SwAlert } from "components/Alert";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
import { FnBlock_UI } from "components/BlockUI";

const UserRegisterForm = () => {
    const { objMasterData } = useContext(RecruitmentContext);
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [nReplyID1, setnReplyID1] = useState(null);
    const [nReplyID7, setnReplyID7] = useState(null);
    const [nReplyID8, setnReplyID8] = useState(null);
    const [nReplyID9, setnReplyID9] = useState(null);
    const [nReplyID11, setnReplyID11] = useState(null);
    const [nReplyID3, setnReplyID3] = useState(null);
    const [nReplyID10, setnReplyID10] = useState(null);
    const [nReplyID12, setnReplyID12] = useState(null);
    const [arrFile, setarrFile] = useState([]);

    const [objFileImg, setobjFileImg] = useState(null);

    const [nSexID, setnSexID] = useState(null);
    const [arrDistrict1, setarrDistrict1] = useState([]);
    const [arrDistrict2, setarrDistrict2] = useState([]);
    const [arrTambon1, setarrTambon1] = useState([]);
    const [arrTambon2, setarrTambon2] = useState([]);
    const [isSameAddress, setisSameAddress] = useState(false);
    const [arrStudy, setarrStudy] = useState([]);
    const [arrLanguageAbility, setarrLanguageAbility] = useState([]);
    const [arrTWorkHistory, setarrTWorkHistory] = useState([]);
    const [arrTrainingHistory, setarrTrainingHistory] = useState([]);
    const [dGraduationDate, setdGraduationDate] = useState(new Date() as any);
    const [dAdmissionDate, setdAdmissionDate] = useState(new Date(1955, 1, 1) as any);

    const [dStartDateWrok, setdStartDateWrok] = useState(new Date(1955, 1, 1) as any);
    const [dEndDateWrok, setdEndDateWrok] = useState(new Date() as any);

    const [dStartDateCourse, setdStartDateCourse] = useState(new Date(1955, 1, 1) as any);
    const [dEndDateCourse, setdEndDateCourse] = useState(new Date() as any);

    const objSchema = yup.object().shape({
        nPositionID: yupFormSchemas.string("ตำเหน่งงานที่สนใจ", { required: true }),
        nSalary: yupFormSchemas.string("เงินเดือนขั้นต่ำที่คาดหวัง", { required: true }),
        nNewSourceID: yupFormSchemas.string("แหล่งข่าวการสมัครงาน", { required: true }),
        sIDCard: yupFormSchemas.stringIDCard("เลขที่บัตรประชาชน", { required: true }),
        dIDcardExpiration: yupFormSchemas.string("วันที่หมดอายุ", { required: true }),
        nPrefixID: yupFormSchemas.string("คำนำหน้า", { required: true }),
        sFirstName_TH: yupFormSchemas.string("ชื่อ (ไทย)", { required: true }),
        sLastName_TH: yupFormSchemas.string("นามสกุล (ไทย)", { required: true }),
        sFirstName_EN: yupFormSchemas.string("ชื่อ (อังกฤษ)", { required: true }),
        sLastName_EN: yupFormSchemas.string("นามสกุล (อังกฤษ)", { required: true }),
        sNickname: yupFormSchemas.string("ชื่อเล่น", { required: true }),
        dBirthday: yupFormSchemas.date("วันเกิด", { required: true }),
        nNationalityID: yupFormSchemas.string("สัญชาติ", { required: true }),
        nEthnicityID: yupFormSchemas.string("เชื้อชาติ", { required: true }),
        nReligionID: yupFormSchemas.string("ศาสนา", { required: true }),
        nSexID: yupFormSchemas.string("เพศ", { required: true }),
        nMaritalStatusID: yupFormSchemas.string("สถานภาพสมรส", { required: true }),
        nWeight: yupFormSchemas.string("น้ำหนัก", { required: true }),
        nHeight: yupFormSchemas.string("ส่วนสูง", { required: true }),
        nMilitaryStatusID: yupFormSchemas.string("สถานภาพทางทหาร", { required: nSexID === 15 }),
        sVillage1: yupFormSchemas.string("หมู่บ้าน", { required: false }),
        sHouseNumber1: yupFormSchemas.string("เลขที", { required: true }),
        nMoo1: yupFormSchemas.string("หมู่ที่", { required: false }),
        sChoi1: yupFormSchemas.string("ชอย", { required: false }),
        sRoad1: yupFormSchemas.string("ถนน", { required: false }),
        nProvince1ID: yupFormSchemas.string("จังหวัด", { required: true }),
        nDistrict1ID: yupFormSchemas.string("อำเภอ/เขต", { required: true }),
        nSubDistrict1ID: yupFormSchemas.string("ตำบล/แขวง", { required: true }),
        sZipCode1: yupFormSchemas.string("รหัสไปรษณีย์", { required: true }),
        sVillage2: yupFormSchemas.string("หมู่บ้าน", { required: false }),
        sHouseNumber2: yupFormSchemas.string("เลขที", { required: true }),
        nMoo2: yupFormSchemas.string("หมู่ที่", { required: false }),
        sChoi2: yupFormSchemas.string("ชอย", { required: false }),
        sRoad2: yupFormSchemas.string("ถนน", { required: false }),
        nProvince2ID: yupFormSchemas.string("จังหวัด", { required: true }),
        nDistrict2ID: yupFormSchemas.string("อำเภอ/เขต", { required: true }),
        nSubDistrict2ID: yupFormSchemas.string("ตำบล/แขวง", { required: true }),
        sZipCode2: yupFormSchemas.string("รหัสไปรษณีย์", { required: true }),
        sEmail: yupFormSchemas.email("อีเมล์", { required: true }),
        sIDLine: yupFormSchemas.string("ID Line", { required: false }),
        sFacebook: yupFormSchemas.string("Facebook", { required: false }),
        sMobileNumber: yupFormSchemas.string("เบอร์มือถือ", { required: true }).min(10, "เบอร์มือถือไม่ถูกต้อง"),
        sContactFName: yupFormSchemas.string("ชื่อ", { required: true }),
        sContactLName: yupFormSchemas.string("นามสกุล", { required: true }),
        sRelationshipID: yupFormSchemas.string("ความสัมพันธ์", { required: true }),
        sContactMobile: yupFormSchemas.string("เบอร์มือถือ", { required: true }).min(10, "เบอร์มือถือไม่ถูกต้อง"),
        sContactFName1: yupFormSchemas.string("ชื่อบุคคลอื่นๆ", { required: true }),
        sContactLName1: yupFormSchemas.string("นามสกุล", { required: true }),
        sRelationship1: yupFormSchemas.string("ความสัมพันธ์", { required: true }),
        sContactMobile1: yupFormSchemas.string("เบอร์มือถือ", { required: true }).min(10, "เบอร์มือถือไม่ถูกต้อง"),
        nTypingAbility_TH: yupFormSchemas.string("ไทย คำ/นาที", { required: true }),
        nTypingAbility_EN: yupFormSchemas.string("อังกฤษ คำ/นาที", { required: true }),
        isInternet: yupFormSchemas.string("Internet/Email", { required: true }),
        arrComputerPrograml: yupFormSchemas.stringArray("โปรแกรมคอมพิวเตอร์ที่ใช้ได้", { required: false }),
        sOtherAbilities: yupFormSchemas.string("ความสามารถอื่นๆ", { required: false }),
        nReplyID1: yupFormSchemas.string("", { required: true }),
        nReplyID2: yupFormSchemas.string("", { required: true }),
        nReplyID3: yupFormSchemas.string("", { required: true }),
        nReplyID4: yupFormSchemas.string("", { required: true }),
        nReplyID5: yupFormSchemas.string("", { required: true }),
        nReplyID6: yupFormSchemas.string("", { required: true }),
        nReplyID7: yupFormSchemas.string("", { required: true }),
        nReplyID8: yupFormSchemas.string("", { required: true }),
        nReplyID9: yupFormSchemas.string("", { required: true }),
        nReplyID10: yupFormSchemas.string("", { required: true }),
        nReplyID11: yupFormSchemas.string("", { required: true }),
        sOther11: yupFormSchemas.string("", { required: nReplyID11 === 81 }),
        nReplyID12: yupFormSchemas.string("", { required: nSexID == 15 ? false : true }),
        nGestational12: yupFormSchemas.string("", { required: nReplyID12 === 83 }),
        sOther9: yupFormSchemas.string("", { required: nReplyID9 === 94 }),
        lstOptionReplyID1: yupFormSchemas.stringArray("", { required: nReplyID1 === 63 }),
        lstOptionReplyID3: yupFormSchemas.stringArray("", { required: nReplyID3 === 67 }),
    });

    const form = useForm({
        resolver: yupResolver(objSchema),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    useEffect(() => {
        console.log("d", moment(objMasterData?.objData?.objFormData?.dBirthdayDate));

        form.reset(objMasterData?.objData?.objFormData)
        form.setValue("nPositionID", undefinedOrNull(objMasterData?.objData?.objFormData?.nPositionID, "string"));
        form.setValue("nRecruitmentID", undefinedOrNull(objMasterData?.objData?.objFormData?.nRecruitmentID, "string"));
        form.setValue("nNewSourceID", undefinedOrNull(objMasterData?.objData?.objFormData?.nNewSourceID, "string"));
        form.setValue("nPrefixID", undefinedOrNull(objMasterData?.objData?.objFormData?.nPrefixID, "string"));
        if (objMasterData?.objData?.objFormData?.dIDcardExpirationDate) {
            form.setValue("dIDcardExpiration", moment(objMasterData?.objData?.objFormData?.dIDcardExpirationDate));
        }
        form.setValue("dBirthday", moment(objMasterData?.objData?.objFormData?.dBirthdayDate));
        form.setValue("nNationalityID", undefinedOrNull(objMasterData?.objData?.objFormData?.nNationalityID, "string"));
        form.setValue("nEthnicityID", undefinedOrNull(objMasterData?.objData?.objFormData?.nEthnicityID, "string"));
        form.setValue("nReligionID", undefinedOrNull(objMasterData?.objData?.objFormData?.nReligionID, "string"));
        form.setValue("nSexID", undefinedOrNull(objMasterData?.objData?.objFormData?.nSexID, "string"));
        form.setValue("nMaritalStatusID", undefinedOrNull(objMasterData?.objData?.objFormData?.nMaritalStatusID, "string"));
        form.setValue("nMilitaryStatusID", undefinedOrNull(objMasterData?.objData?.objFormData?.nMilitaryStatusID, "string"));
        form.setValue("nProvince1ID", undefinedOrNull(objMasterData?.objData?.objFormData?.nProvince1ID, "string"));
        form.setValue("nDistrict1ID", undefinedOrNull(objMasterData?.objData?.objFormData?.nDistrict1ID, "string"));
        form.setValue("nSubDistrict1ID", undefinedOrNull(objMasterData?.objData?.objFormData?.nSubDistrict1ID, "string"));
        setisSameAddress(objMasterData?.objData?.objFormData?.isSameAddress)
        GetDistrictRegister(objMasterData?.objData?.objFormData?.nProvince1ID, 1);
        GetTambonRegister(objMasterData?.objData?.objFormData?.nDistrict1ID, 1);
        form.setValue("nProvince2ID", undefinedOrNull(objMasterData?.objData?.objFormData?.nProvince2ID, "string"));
        form.setValue("nDistrict2ID", undefinedOrNull(objMasterData?.objData?.objFormData?.nDistrict2ID, "string"));
        form.setValue("nSubDistrict2ID", undefinedOrNull(objMasterData?.objData?.objFormData?.nSubDistrict2ID, "string"));
        GetDistrictRegister(objMasterData?.objData?.objFormData?.nProvince2ID, 2);
        GetTambonRegister(objMasterData?.objData?.objFormData?.nDistrict2ID, 2);
        form.setValue("sRelationshipID", undefinedOrNull(objMasterData?.objData?.objFormData?.sRelationshipID, "string"));
        setnReplyID3(objMasterData?.objData?.objFormData?.nReplyID3);
        setnReplyID1(objMasterData?.objData?.objFormData?.nReplyID1);
        setnReplyID7(objMasterData?.objData?.objFormData?.nReplyID7);
        setnReplyID8(objMasterData?.objData?.objFormData?.nReplyID8);
        setnReplyID9(objMasterData?.objData?.objFormData?.nReplyID9);
        setnReplyID11(objMasterData?.objData?.objFormData?.nReplyID11);
        setnReplyID10(objMasterData?.objData?.objFormData?.nReplyID10);
        setnReplyID12(objMasterData?.objData?.objFormData?.nReplyID12);
        setnSexID(objMasterData?.objData?.objFormData?.nSexID);
        setarrStudy(objMasterData?.objData?.arrStudy || []);
        setarrLanguageAbility(objMasterData?.objData?.arrLanguageAbility || []);
        setarrTWorkHistory(objMasterData?.objData?.arrTWorkHistory || []);
        setarrTrainingHistory(objMasterData?.objData?.arrTrainingHistory || []);
        setarrFile(objMasterData?.objData?.lstFileUpLoad || []);
        setobjFileImg(objMasterData?.objData?.objFileImg || {})
    }, [objMasterData?.objData])

    const GetDistrictRegister = (nProvinceID: number, Mode: number) => {
        BlockUI();
        AxiosPost("Register/GetDistrictRegister", { nProvinceID: nProvinceID }, (res) => {
            if (Mode === 1) {
                setarrDistrict1(res || []);
            } else {
                setarrDistrict2(res || []);
            }
        }, null, null, null, () => {
            UnBlockUI();
        })
    }
    const GetTambonRegister = (nDistrictID: number, Mode: number) => {
        BlockUI();
        AxiosPost("Register/GetTambonRegister", { nDistrictID: nDistrictID }, (res) => {
            if (Mode === 1) {
                setarrTambon1(res || []);
            } else {
                setarrTambon2(res || []);
            }
        }, null, null, null, () => {
            UnBlockUI();
        })
    }
    //#region Popup Study
    const [nStudyEditID, setStudynEditID] = useState(null);
    const [openPopupStudy, setOpenPopupStudy] = useState(false);
    const objSchemaStudy = yup.object().shape({
        nEducationLevelID: yupFormSchemas.string("ระดับการศึกษา", { required: true }),
        sInstitution: yupFormSchemas.string("สถาบัน", { required: true }),
        sBranch: yupFormSchemas.string("สาขาวิชา", { required: true }),
        nGPA: yupFormSchemas.string("GPA", { required: true }),
        dAdmissionDate: yupFormSchemas.string("วันที่เข้าศึกษา", { required: true }),
        dGraduationDate: yupFormSchemas.string("วันที่จบศึกษา", { required: true }),
    });

    const formStudy = useForm({
        resolver: yupResolver(objSchemaStudy),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    const onSaveStudy = () => {
        let qEducationLevel = new List<any>(objMasterData.lstEducationLevel || []).FirstOrDefault(w => w.value == formStudy.getValues("nEducationLevelID"));
        if (nStudyEditID) {
            let qStudy = new List<TEducationalRecord>(arrStudy || []).FirstOrDefault(w => w.nID == nStudyEditID);
            if (qStudy) {
                qStudy.dAdmissionDate = undefinedOrNull(formStudy.getValues("dAdmissionDate"), "dateToString");
                qStudy.dGraduationDate = undefinedOrNull(formStudy.getValues("dGraduationDate"), "dateToString");
                qStudy.nEducationLevelID = undefinedOrNull(formStudy.getValues("nEducationLevelID"), "number");
                qStudy.nGPA = undefinedOrNull(formStudy.getValues("nGPA"), "number");
                qStudy.sBranch = undefinedOrNull(formStudy.getValues("sBranch"), "string");
                qStudy.sEducationLeve = qEducationLevel ? qEducationLevel.label : "";
                qStudy.sInstitution = undefinedOrNull(formStudy.getValues("sInstitution"), "string");
            }
        } else {
            let lstarrStudy = new List<TEducationalRecord>(arrStudy || []).ToList();
            let MaxID = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nID) + 1 : 1
            let MaxNo = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nNo) + 1 : 1
            let data: TEducationalRecord = {
                nID: MaxID,
                nNo: MaxNo,
                dAdmissionDate: undefinedOrNull(formStudy.getValues("dAdmissionDate"), "dateToString"),
                dGraduationDate: undefinedOrNull(formStudy.getValues("dGraduationDate"), "dateToString"),
                nEducationLevelID: undefinedOrNull(formStudy.getValues("nEducationLevelID"), "number"),
                nGPA: undefinedOrNull(formStudy.getValues("nGPA"), "number"),
                nOrderID: MaxNo,
                sBranch: undefinedOrNull(formStudy.getValues("sBranch"), "string"),
                sEducationLeve: qEducationLevel ? qEducationLevel.label : "",
                sInstitution: undefinedOrNull(formStudy.getValues("sInstitution"), "string"),
            }
            setarrStudy([...arrStudy, { ...data }])
        }
        handleClosePopupStudy(null, "");
    };
    const handleClosePopupStudy = (event: object, reason: string) => {
        if (reason != "backdropClick") {
            formStudy.setValue("nEducationLevelID", null);
            formStudy.setValue("sInstitution", null);
            formStudy.setValue("sBranch", null);
            formStudy.setValue("nGPA", null);
            formStudy.setValue("dAdmissionDate", null);
            formStudy.setValue("dGraduationDate", null);
            formStudy.clearErrors();
            setdGraduationDate(new Date())
            setdAdmissionDate(new Date(1955, 1, 1))
            setOpenPopupStudy(false);
            setStudynEditID(null);
        }
    };
    const onEditStudy = (obj: TEducationalRecord) => {
        setStudynEditID(obj.nID);
        formStudy.setValue("nEducationLevelID", undefinedOrNull(obj.nEducationLevelID, "string"));
        formStudy.setValue("sInstitution", undefinedOrNull(obj.sInstitution, "string"));
        formStudy.setValue("sBranch", undefinedOrNull(obj.sBranch, "string"));
        formStudy.setValue("nGPA", undefinedOrNull(obj.nGPA, "string"));
        formStudy.setValue("dAdmissionDate", undefinedOrNull(obj.dAdmissionDate, "string"));
        formStudy.setValue("dGraduationDate", undefinedOrNull(obj.dGraduationDate, "string"));
        setdGraduationDate(obj.dGraduationDate ? moment(obj.dGraduationDate) : new Date())
        setdAdmissionDate(obj.dAdmissionDate ? moment(obj.dAdmissionDate) : new Date(1955, 1, 1))
        setOpenPopupStudy(true);
    }
    const ColumnData: ColumnProps[] = [{
        id: "nNo",
        name: "ลำดับ",
        width: "5%",
    },
    {
        id: "sEducationLeve",
        name: "ระดับ",
        width: "15%",
        cellAlign: "left"
    },
    {
        id: "sInstitution",
        name: "สถาบัน",
        width: "30%",
        cellAlign: "left"
    },
    {
        id: "sBranch",
        name: "สาขา",
        width: "30%",
        cellAlign: "left"
    },
    {
        id: "nGPA",
        name: "GPA",
        width: "10%",
        cellAlign: "right"
    },
    {
        id: "Action",
        name: "",
        width: "5%",
        renderCell: (item) => {
            return (
                <div style={{ display: "inline-flex", textAlign: "center" }}>
                    {objMasterData.isEditData ?
                        <>
                            <BtnEditTable onClick={() => { onEditStudy(item) }} />
                            <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDeleteStudy(item) }} />
                        </> : (<BtnViewTable title="รายละเอียด" style={{ marginLeft: "5px" }} onClick={() => onEditStudy(item)} />)
                    }

                </div>
            )
        }
    }];
    const onDeleteStudy = (obj: TEducationalRecord) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            setarrStudy(new List<TEducationalRecord>(arrStudy || []).Where(w => w.nID != obj.nID).ToArray())
        });
    }
    //#endregion

    //#region  pupup Language
    const [openLanguage, setOpenLanguage] = useState(false);
    const [nLanguageEditID, setLanguagenEditID] = useState(null);
    const objSchemaLanguage = yup.object().shape({
        nlanguageID: yupFormSchemas.string("ภาษา", { required: true }),
        nSpeakingID: yupFormSchemas.string("การพูด", { required: true }),
        nReadingID: yupFormSchemas.string("การอ่าน", { required: true }),
        nWritingID: yupFormSchemas.string("การเขียน", { required: true }),
        nListenID: yupFormSchemas.string("การฟัง", { required: true }),
    });

    const formLanguage = useForm({
        resolver: yupResolver(objSchemaLanguage),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    const handleCloseLanguage = (event: object, reason: string) => {
        if (reason != "backdropClick") {
            formLanguage.setValue("nlanguageID", null);
            formLanguage.setValue("nSpeakingID", null);
            formLanguage.setValue("nReadingID", null);
            formLanguage.setValue("nWritingID", null);
            formLanguage.setValue("nListenID", null);
            formLanguage.setValue("nToeic", null);
            formLanguage.setValue("nToefl", null);
            formLanguage.clearErrors();
            setLanguagenEditID(null);
            setOpenLanguage(false);
        }
    };
    const onDeleteLanguage = (obj: TLanguageAbility) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            setarrLanguageAbility(new List<TLanguageAbility>(arrLanguageAbility || []).Where(w => w.nlanguageID != obj.nlanguageID).ToArray())
        });
    }
    const onEditLanguage = (obj: TLanguageAbility) => {
        setLanguagenEditID(obj.nlanguageID);
        console.log("required", obj.nlanguageID);

        formLanguage.setValue("nlanguageID", undefinedOrNull(obj.nlanguageID, "string"));
        formLanguage.setValue("nSpeakingID", undefinedOrNull(obj.nSpeakingID, "string"));
        formLanguage.setValue("nReadingID", undefinedOrNull(obj.nReadingID, "string"));
        formLanguage.setValue("nWritingID", undefinedOrNull(obj.nWritingID, "string"));
        formLanguage.setValue("nListenID", undefinedOrNull(obj.nListenID, "string"));
        formLanguage.setValue("nToeic", undefinedOrNull(obj.nToeic, "string"));
        formLanguage.setValue("nToefl", undefinedOrNull(obj.nToefl, "string"));
        setOpenLanguage(true);
    }
    const onSaveLanguage = () => {
        let qlanguage = new List<any>(objMasterData.lstLanguage || []).FirstOrDefault(w => w.value == formLanguage.getValues("nlanguageID"));
        let qSpeaking = new List<any>(objMasterData.lstSkillLevel || []).FirstOrDefault(w => w.value == formLanguage.getValues("nSpeakingID"));
        let qReading = new List<any>(objMasterData.lstSkillLevel || []).FirstOrDefault(w => w.value == formLanguage.getValues("nReadingID"));
        let qWriting = new List<any>(objMasterData.lstSkillLevel || []).FirstOrDefault(w => w.value == formLanguage.getValues("nWritingID"));
        let qListen = new List<any>(objMasterData.lstSkillLevel || []).FirstOrDefault(w => w.value == formLanguage.getValues("nListenID"));
        if (nLanguageEditID) {
            let qStudy = new List<TLanguageAbility>(arrLanguageAbility || []).FirstOrDefault(w => w.nlanguageID == nLanguageEditID);
            if (qStudy) {
                qStudy.nSpeakingID = undefinedOrNull(formLanguage.getValues("nSpeakingID"), "number");
                qStudy.nReadingID = undefinedOrNull(formLanguage.getValues("nReadingID"), "number");
                qStudy.nWritingID = undefinedOrNull(formLanguage.getValues("nWritingID"), "number");
                qStudy.nListenID = undefinedOrNull(formLanguage.getValues("nListenID"), "number");
                qStudy.slanguageName = qlanguage ? qlanguage.label : "";
                qStudy.sSpeakingName = qSpeaking ? qSpeaking.label : "";
                qStudy.sReadingName = qReading ? qReading.label : "";
                qStudy.sWritingName = qWriting ? qWriting.label : "";
                qStudy.sListenName = qListen ? qListen.label : "";
                qStudy.nToeic = undefinedOrNull(formLanguage.getValues("nToeic"), "number");
                qStudy.nToefl = undefinedOrNull(formLanguage.getValues("nToefl"), "number");
            }
            handleCloseLanguage(null, "");
        } else {
            let lstarrStudy = new List<TLanguageAbility>(arrLanguageAbility || []).ToList();
            if (lstarrStudy.Any(a => a.nlanguageID === undefinedOrNull(formLanguage.getValues("nlanguageID"), "number"))) {
                SwAlert.Warning(AlertTitle.Warning, "ท่านได้ทำการระบุความสามารถด้านภาษา" + (qlanguage ? qlanguage.label : "") + "ไปแล้ว", () => { });
            } else {
                let MaxNo = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nNo) + 1 : 1
                let data: TLanguageAbility = {
                    nlanguageID: undefinedOrNull(formLanguage.getValues("nlanguageID"), "number"),
                    nNo: MaxNo,
                    nSpeakingID: undefinedOrNull(formLanguage.getValues("nSpeakingID"), "number"),
                    nReadingID: undefinedOrNull(formLanguage.getValues("nReadingID"), "number"),
                    nWritingID: undefinedOrNull(formLanguage.getValues("nWritingID"), "number"),
                    nListenID: undefinedOrNull(formLanguage.getValues("nListenID"), "number"),
                    nToeic: undefinedOrNull(formLanguage.getValues("nToeic"), "number"),
                    nToefl: undefinedOrNull(formLanguage.getValues("nToefl"), "number"),
                    nOrderID: MaxNo,
                    slanguageName: qlanguage ? qlanguage.label : "",
                    sSpeakingName: qSpeaking ? qSpeaking.label : "",
                    sReadingName: qReading ? qReading.label : "",
                    sWritingName: qWriting ? qWriting.label : "",
                    sListenName: qListen ? qListen.label : "",
                }
                setarrLanguageAbility([...arrLanguageAbility, { ...data }])
                handleCloseLanguage(null, "");
            }
        }

    };
    const ColumnLanguageAbilityData: ColumnProps[] = [{
        id: "nNo",
        name: "ลำดับ",
        width: "5%",
    },
    {
        id: "slanguageName",
        name: "ภาษา",
        width: "30%",
        cellAlign: "center"
    },
    {
        id: "sSpeakingName",
        name: "การพูด",
        width: "15%",
        cellAlign: "center"
    },
    {
        id: "sReadingName",
        name: "การอ่าน",
        width: "15%",
        cellAlign: "center"
    },
    {
        id: "sWritingName",
        name: "การเขียน",
        width: "15%",
        cellAlign: "center"
    },
    {
        id: "sListenName",
        name: "การฟัง",
        width: "15%",
        cellAlign: "center"
    },
    {
        id: "Action",
        name: "",
        width: "5%",
        renderCell: (item) => {
            return (
                <div style={{ display: "inline-flex", textAlign: "center" }}>
                    {objMasterData.isEditData ?
                        <>
                            <BtnEditTable onClick={() => { onEditLanguage(item) }} />
                            <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDeleteLanguage(item) }} />
                        </> : (<BtnViewTable title="รายละเอียด" style={{ marginLeft: "5px" }} onClick={() => onEditLanguage(item)} />)
                    }
                </div>
            )
        }
    }]
    //#endregion

    //#region  puup Work
    const [openWork, setOpenWork] = useState(false);
    const [nEditWorkID, setnEditWorkID] = useState(null);
    const [isNow, setisNow] = useState(false);
    const objSchemaWork = yup.object().shape({
        sCompanyName: yupFormSchemas.string("ชื่อบริษัท", { required: true }),
        sPosition: yupFormSchemas.string("ตำแหน่ง", { required: true }),
        dStartDate: yupFormSchemas.string("วันที่เข้าทำงาน", { required: true }),
        dEndDate: yupFormSchemas.string("วันที่ทำงานสุดท้าย", { required: isNow ? false : true }),
        sBehavior: yupFormSchemas.string("ลักษณะการทำงาน", { required: true }),
        sReasonForLeaving: yupFormSchemas.string("สาเหตุที่ออก", { required: false }),
    });

    const formWork = useForm({
        resolver: yupResolver(objSchemaWork),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    const ColumnWorkHistorData: ColumnProps[] = [{
        id: "nNo",
        name: "ลำดับ",
        width: "5%",
    },
    {
        id: "sCompanyName",
        name: "ชื่อบริษัท",
        width: "20%",
        cellAlign: "left"
    },
    {
        id: "sPosition",
        name: "ตำแหน่ง",
        width: "10%",
        cellAlign: "left"
    },
    {
        id: "sRangeDate",
        name: "ระยะเวลา",
        width: "15%",
        cellAlign: "center"
    },
    {
        id: "sBehavior",
        name: "ลักษณะการทำงาน",
        width: "20%",
        cellAlign: "left"
    },
    {
        id: "sReasonForLeaving",
        name: "สาเหตุที่ออก",
        width: "20%",
        cellAlign: "left"
    },
    {
        id: "Action",
        name: "",
        width: "5%",
        renderCell: (item) => {
            return (
                <div style={{ display: "inline-flex", textAlign: "center" }}>
                    {objMasterData.isEditData ? <>
                        <BtnEditTable onClick={() => { onEditWork(item) }} />
                        <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDeleteWork(item) }} />
                    </> : (<BtnViewTable title="รายละเอียด" style={{ marginLeft: "5px" }} onClick={() => onEditWork(item)} />)
                    }
                </div>
            )
        }
    }]

    const handleCloseWork = (event: object, reason: string) => {
        if (reason != "backdropClick") {
            formWork.setValue("sCompanyName", null);
            formWork.setValue("sPosition", null);
            formWork.setValue("dStartDate", null);
            formWork.setValue("dEndDate", null);
            formWork.setValue("sBehavior", null);
            formWork.setValue("sReasonForLeaving", null);
            formWork.setValue("isNow", false);
            formWork.setValue("nSalary", null);
            setdEndDateWrok(null);
            setdEndDateWrok(null);
            setisNow(false);
            formWork.clearErrors();
            setnEditWorkID(null);
            setOpenWork(false);
        }
    };
    const onSaveWork = () => {
        if (nEditWorkID) {
            let qStudy = new List<TWorkHistory>(arrTWorkHistory || []).FirstOrDefault(w => w.nID == nEditWorkID);
            if (qStudy) {
                qStudy.isNow = formWork.getValues("isNow");
                qStudy.sCompanyName = undefinedOrNull(formWork.getValues("sCompanyName"), "string");
                qStudy.sPosition = undefinedOrNull(formWork.getValues("sPosition"), "string");
                qStudy.dStartDate = undefinedOrNull(formWork.getValues("dStartDate"), "dateToString");
                qStudy.dEndDate = undefinedOrNull(formWork.getValues("dEndDate"), "dateToString");
                qStudy.sBehavior = undefinedOrNull(formWork.getValues("sBehavior"), "string");
                qStudy.sReasonForLeaving = undefinedOrNull(formWork.getValues("sReasonForLeaving"), "string");
                qStudy.nSalary = undefinedOrNull(formWork.getValues("nSalary"), "number");
                qStudy.dStartDateData = formWork.getValues("dStartDate");
                qStudy.dEndDateData = formWork.getValues("dEndDate");
                qStudy.sRangeDate = (moment(qStudy.dStartDateData).format('MM') + "/" + (moment(qStudy.dStartDateData).year() + 543)) + " - " + (qStudy.isNow ? "ถึงปัจจุบัน" : moment(qStudy.dEndDateData).format('MM') + "/" + (moment(qStudy.dEndDateData).year() + 543));
            }

        } else {
            let lstarrStudy = new List<TWorkHistory>(arrTWorkHistory || []).ToList();
            let MaxID = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nID) + 1 : 1
            let MaxNo = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nNo) + 1 : 1
            let data: TWorkHistory = {
                nID: MaxID,
                nNo: MaxNo,
                nOrderID: MaxNo,
                isNow: formWork.getValues("isNow"),
                sCompanyName: undefinedOrNull(formWork.getValues("sCompanyName"), "string"),
                sPosition: undefinedOrNull(formWork.getValues("sPosition"), "string"),
                dStartDate: undefinedOrNull(formWork.getValues("dStartDate"), "dateToString"),
                dEndDate: undefinedOrNull(formWork.getValues("dEndDate"), "dateToString"),
                dStartDateData: formWork.getValues("dStartDate"),
                dEndDateData: formWork.getValues("dEndDate"),
                sBehavior: undefinedOrNull(formWork.getValues("sBehavior"), "string"),
                sReasonForLeaving: undefinedOrNull(formWork.getValues("sReasonForLeaving"), "string"),
                nSalary: undefinedOrNull(formWork.getValues("nSalary"), "number"),
                sRangeDate: (moment(formWork.getValues("dStartDate")).format('MM') + "/" + (moment(formWork.getValues("dStartDate")).year() + 543)) + " - " + (formWork.getValues("isNow") ? "ถึงปัจจุบัน" : (moment(formWork.getValues("dEndDate")).format('MM') + "/" + (moment(formWork.getValues("dEndDate")).year() + 543)))
            }

            setarrTWorkHistory([...arrTWorkHistory, { ...data }])
        }
        handleCloseWork(null, "");
    };
    const onDeleteWork = (obj: TWorkHistory) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            setarrTWorkHistory(new List<TWorkHistory>(arrTWorkHistory || []).Where(w => w.nID != obj.nID).ToArray())
        });
    }
    const onEditWork = (obj: TWorkHistory) => {
        setnEditWorkID(obj.nID);
        formWork.setValue("sCompanyName", undefinedOrNull(obj.sCompanyName, "string"));
        formWork.setValue("sPosition", undefinedOrNull(obj.sPosition, "string"));
        formWork.setValue("dStartDate", moment(obj.dStartDateData));
        formWork.setValue("dEndDate", moment(obj.dEndDateData));
        formWork.setValue("sBehavior", undefinedOrNull(obj.sBehavior, "string"));
        formWork.setValue("sReasonForLeaving", undefinedOrNull(obj.sReasonForLeaving, "string"));
        formWork.setValue("nSalary", undefinedOrNull(obj.nSalary, "string"));
        formWork.setValue("isNow", obj.isNow);
        if (obj.dStartDate) {
            setdEndDateWrok(obj.dStartDate ? moment(obj.dStartDateData) : new Date());
        }
        if (obj.dEndDate) {
            setdEndDateWrok(obj.dEndDate ? moment(obj.dEndDateData) : new Date(1955, 1, 1));
        }
        setisNow(obj.isNow);
        setOpenWork(true);
    }
    //#endregion

    //#region  Training
    const [openTraining, setOpenTraining] = useState(false);
    const [nTrainingID, setnTrainingID] = useState(null);
    const ColumnDataTraining: ColumnProps[] = [{
        id: "nNo",
        name: "ลำดับ",
        width: "5%",
    },
    {
        id: "sCourseName",
        name: "ชื่อหลักสูตรที่เข้ารับการอบรม",
        width: "20%",
        cellAlign: "left"
    },
    {
        id: "sCompanyName",
        name: "ซื่อบริษัท",
        width: "15%",
        cellAlign: "left"
    },
    {
        id: "sRangeDate",
        name: "ระยะเวลา",
        width: "10%",
        cellAlign: "center"
    },
    {
        id: "sNatureTraining",
        name: "ลักษณะการอบรม",
        width: "20%",
        cellAlign: "left"
    },
    {
        id: "Action",
        name: "",
        width: "5%",
        renderCell: (item) => {
            return (
                <div style={{ display: "inline-flex", textAlign: "center" }}>
                    {objMasterData.isEditData ?
                        <>
                            <BtnEditTable onClick={() => { onEditTraining(item) }} />
                            <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDeleteTraining(item) }} />
                        </> : (<BtnViewTable title="รายละเอียด" style={{ marginLeft: "5px" }} onClick={() => onEditTraining(item)} />)}
                </div>
            )
        }
    }]
    const handleCloseTraining = (event: object, reason: string) => {
        if (reason != "backdropClick") {
            formTraining.setValue("sCourseName", null);
            formTraining.setValue("sCompanyName", null);
            formTraining.setValue("dStartDate", null);
            formTraining.setValue("dEndDate", null);
            formTraining.setValue("sNatureTraining", null);
            formTraining.clearErrors();
            setdEndDateCourse(null);
            setdEndDateCourse(null);
            setnTrainingID(null);
            setOpenTraining(false);
        }
    };
    const objSchemaTraining = yup.object().shape({
        sCourseName: yupFormSchemas.string("ชื่อหลักสูตร", { required: true }),
        sCompanyName: yupFormSchemas.string("ชื่อบริษัท", { required: true }),
        dStartDate: yupFormSchemas.string("วันที่เริ่ม", { required: true }),
        dEndDate: yupFormSchemas.string("วันที่จบ", { required: true }),
        sNatureTraining: yupFormSchemas.string("ลักษณะการอบรม", { required: true }),
    });

    const formTraining = useForm({
        resolver: yupResolver(objSchemaTraining),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    const onSaveTraining = () => {
        if (nTrainingID) {
            let qStudy = new List<TrainingHistory>(arrTrainingHistory || []).FirstOrDefault(w => w.nID == nTrainingID);
            if (qStudy) {

                qStudy.sCompanyName = undefinedOrNull(formTraining.getValues("sCompanyName"), "string");
                qStudy.dStartDate = undefinedOrNull(formTraining.getValues("dStartDate"), "dateToString");
                qStudy.dEndDate = isNow ? null : undefinedOrNull(formTraining.getValues("dEndDate"), "dateToString");
                qStudy.sCourseName = undefinedOrNull(formTraining.getValues("sCourseName"), "string");
                qStudy.sNatureTraining = undefinedOrNull(formTraining.getValues("sNatureTraining"), "string");
                qStudy.dStartDateData = formTraining.getValues("dStartDate");
                qStudy.dEndDateData = formTraining.getValues("dEndDate");
                qStudy.sRangeDate = qStudy.sRangeDate = (moment(qStudy.dStartDateData).format('MM') + "/" + (moment(qStudy.dStartDateData).year() + 543)) + " - " + moment(qStudy.dEndDateData).format('MM') + "/" + (moment(qStudy.dEndDateData).year() + 543);
            }
        } else {
            let lstarrStudy = new List<TrainingHistory>(arrTrainingHistory || []).ToList();
            let MaxID = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nID) + 1 : 1
            let MaxNo = lstarrStudy.Any() ? lstarrStudy.Max(m => m.nNo) + 1 : 1
            let data: TrainingHistory = {
                nID: MaxID,
                nNo: MaxNo,
                nOrderID: MaxNo,
                sCompanyName: undefinedOrNull(formTraining.getValues("sCompanyName"), "string"),
                sCourseName: undefinedOrNull(formTraining.getValues("sCourseName"), "string"),
                dStartDate: undefinedOrNull(formTraining.getValues("dStartDate"), "dateToString"),
                dEndDate: undefinedOrNull(formTraining.getValues("dEndDate"), "dateToString"),
                sNatureTraining: undefinedOrNull(formTraining.getValues("sNatureTraining"), "string"),
                dStartDateData: formTraining.getValues("dStartDate"),
                dEndDateData: formTraining.getValues("dEndDate"),
                sRangeDate: (moment(formTraining.getValues("dStartDate")).format('MM') + "/" + (moment(formTraining.getValues("dStartDate")).year() + 543)) + " - " + (moment(formTraining.getValues("dEndDate")).format('MM') + "/" + (moment(formTraining.getValues("dEndDate")).year() + 543))
            }
            setarrTrainingHistory([...arrTrainingHistory, { ...data }])
        }
        handleCloseTraining(null, "");
    };
    const onDeleteTraining = (obj: TrainingHistory) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            setarrTrainingHistory(new List<TWorkHistory>(arrTrainingHistory || []).Where(w => w.nID != obj.nID).ToArray())
        });
    }
    const onEditTraining = (obj: TrainingHistory) => {
        setnTrainingID(obj.nID);
        formTraining.setValue("sCompanyName", undefinedOrNull(obj.sCompanyName, "string"));
        formTraining.setValue("sCourseName", undefinedOrNull(obj.sCourseName, "string"));
        formTraining.setValue("dStartDate", moment(obj.dStartDateData));
        formTraining.setValue("dEndDate", moment(obj.dEndDateData));
        formTraining.setValue("sNatureTraining", undefinedOrNull(obj.sNatureTraining, "string"));
        setdEndDateCourse(obj.dStartDate ? moment(obj.dStartDate) : new Date());
        setdEndDateCourse(obj.dEndDate ? moment(obj.dEndDate) : new Date(1955, 1, 1));
        setOpenTraining(true);
    }
    //#endregion

    //#region Flle
    const ColumnDataFlle: ColumnProps[] = [{
        id: "nNo",
        name: "ลำดับ",
        width: "5%",
    },
    {
        id: "sFileName",
        name: "ชื่อไฟล์",
        width: "85%",
        cellAlign: "left"
    },
    {
        id: "Action",
        name: "",
        width: "10%",
        renderCell: (item) => {
            return (
                <div style={{ display: "inline-flex", textAlign: "center" }}>
                    <BtnViewTable onClick={() => {
                        const a = document.createElement('a');
                        a.href = item.sFileUrl;
                        a.target = "_blank";
                        a.download = item.sFileUrl.split('/').pop();
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }} />
                    {objMasterData.isEditData && <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDeleteFileOthor(item) }} />}
                </div>
            )
        }
    }]
    const onDeleteFileOthor = (obj: FIleItem) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            setarrFile(new List<FIleItem>(arrFile || []).Where(w => w.nID != obj.nID).ToArray())
        });
    };
    const onUploadFileOthor = () => {
        const onClickFile = document.getElementById("onCameraFileOthor");
        if (onClickFile) {
            onClickFile.click();
        }
    }
    const _SendAPIFileOthor = async (_FileItem) => {

        let lstFile_ = _FileItem.target.files;
        await SendAPIFile(lstFile_[0], (res: FIleItem[]) => {
            let _lstFile = new List<FIleItem>(res || []).FirstOrDefault(w => w.IsCompleted);
            let lstFile = new List<FIleItem>(arrFile || []).ToList();;
            if (_lstFile) {
                let macID = lstFile.Any() ? lstFile.Max(m => m.nID) + 1 : 1;
                let macNo = lstFile.Any() ? lstFile.Max(m => m.nNo) + 1 : 1;
                let data: FIleItem = {
                    ..._lstFile,
                    nID: macID,
                    nNo: macNo,
                }
                setarrFile([...arrFile, { ...data }])
            }
        }, (er) => {
            console.log("er", er);
        });

    }
    //#endregion

    const onUploadFile = () => {
        const onClickFile = document.getElementById("onCameraFile");
        if (onClickFile) {
            onClickFile.click();
        }
    }
    const _SendAPIFile = async (FileItem) => {
        let lstFile_ = FileItem.target.files;
        console.log("arrFileItem", lstFile_[0]);
        await SendAPIFile(lstFile_[0], (res) => {
            setobjFileImg(res[0]);
        }, (er) => {
        });

    }

    const Savedata = () => {
        let objData = {
            nID: objMasterData?.objData?.objFormData?.nRegisterID,
            objFileImg: objFileImg,
            nPositionID: undefinedOrNull(form.getValues("nPositionID"), "number"),
            nSalary: undefinedOrNull(form.getValues("nSalary"), "number"),
            nNewSourceID: undefinedOrNull(form.getValues("nNewSourceID"), "number"),
            nRecruitmentID: undefinedOrNull(form.getValues("nRecruitmentID"), "number"),
            sIDCard: undefinedOrNull(form.getValues("sIDCard"), "string"),
            dIDcardExpiration: undefinedOrNull(form.getValues("dIDcardExpiration"), "dateToString"),
            nPrefixID: undefinedOrNull(form.getValues("nPrefixID"), "number"),
            sFirstName_TH: undefinedOrNull(form.getValues("sFirstName_TH"), "string"),
            sLastName_TH: undefinedOrNull(form.getValues("sLastName_TH"), "string"),
            sFirstName_EN: undefinedOrNull(form.getValues("sFirstName_EN"), "string"),
            sLastName_EN: undefinedOrNull(form.getValues("sLastName_EN"), "string"),
            sNickname: undefinedOrNull(form.getValues("sNickname"), "string"),
            dBirthday: undefinedOrNull(form.getValues("dBirthday"), "dateToString"),
            nNationalityID: undefinedOrNull(form.getValues("nNationalityID"), "number"),
            nReligionID: undefinedOrNull(form.getValues("nReligionID"), "number"),
            nEthnicityID: undefinedOrNull(form.getValues("nEthnicityID"), "number"),
            nSexID: undefinedOrNull(form.getValues("nSexID"), "number"),
            nMaritalStatusID: undefinedOrNull(form.getValues("nMaritalStatusID"), "number"),
            nWeight: undefinedOrNull(form.getValues("nWeight"), "number"),
            nHeight: undefinedOrNull(form.getValues("nHeight"), "number"),
            nMilitaryStatusID: undefinedOrNull(form.getValues("nMilitaryStatusID"), "number"),
            sVillage1: undefinedOrNull(form.getValues("sVillage1"), "string"),
            sHouseNumber1: undefinedOrNull(form.getValues("sHouseNumber1"), "string"),
            nMoo1: undefinedOrNull(form.getValues("nMoo1"), "number"),
            sChoi1: undefinedOrNull(form.getValues("sChoi1"), "string"),
            sRoad1: undefinedOrNull(form.getValues("sRoad1"), "string"),
            nProvince1ID: undefinedOrNull(form.getValues("nProvince1ID"), "number"),
            nDistrict1ID: undefinedOrNull(form.getValues("nDistrict1ID"), "number"),
            nSubDistrict1ID: undefinedOrNull(form.getValues("nSubDistrict1ID"), "number"),
            isSameAddress: undefinedOrNull(form.getValues("isSameAddress"), "bool"),
            sZipCode1: undefinedOrNull(form.getValues("sZipCode1"), "string"),
            sVillage2: undefinedOrNull(form.getValues("sVillage2"), "string"),
            sHouseNumber2: undefinedOrNull(form.getValues("sHouseNumber2"), "string"),
            nMoo2: undefinedOrNull(form.getValues("nMoo2"), "number"),
            sChoi2: undefinedOrNull(form.getValues("sChoi2"), "string"),
            sRoad2: undefinedOrNull(form.getValues("sRoad2"), "string"),
            nProvince2ID: undefinedOrNull(form.getValues("nProvince2ID"), "number"),
            nDistrict2ID: undefinedOrNull(form.getValues("nDistrict2ID"), "number"),
            nSubDistrict2ID: undefinedOrNull(form.getValues("nSubDistrict2ID"), "number"),
            sZipCode2: undefinedOrNull(form.getValues("sZipCode2"), "string"),
            sEmail: undefinedOrNull(form.getValues("sEmail"), "string"),
            sIDLine: undefinedOrNull(form.getValues("sIDLine"), "string"),
            sFacebook: undefinedOrNull(form.getValues("sFacebook"), "string"),
            sMobileNumber: undefinedOrNull(form.getValues("sMobileNumber"), "string"),
            sContactFName: undefinedOrNull(form.getValues("sContactFName"), "string"),
            sContactLName: undefinedOrNull(form.getValues("sContactLName"), "string"),
            sRelationshipID: undefinedOrNull(form.getValues("sRelationshipID"), "number"),
            sContactMobile: undefinedOrNull(form.getValues("sContactMobile"), "string"),

            sContactFName1: undefinedOrNull(form.getValues("sContactFName1"), "string"),
            sContactLName1: undefinedOrNull(form.getValues("sContactLName1"), "string"),
            sRelationship1: undefinedOrNull(form.getValues("sRelationship1"), "string"),
            sContactMobile1: undefinedOrNull(form.getValues("sContactMobile1"), "string"),

            nTypingAbility_TH: undefinedOrNull(form.getValues("nTypingAbility_TH"), "number"),
            nTypingAbility_EN: undefinedOrNull(form.getValues("nTypingAbility_EN"), "number"),
            isInternet: undefinedOrNull(form.getValues("isInternet"), "number"),
            arrComputerPrograml: form.getValues("arrComputerPrograml") || [],
            sOtherAbilities: undefinedOrNull(form.getValues("sOtherAbilities"), "string"),
            nReplyID1: undefinedOrNull(form.getValues("nReplyID1"), "number"),
            nReplyID2: undefinedOrNull(form.getValues("nReplyID2"), "number"),
            nReplyID3: undefinedOrNull(form.getValues("nReplyID3"), "number"),
            nReplyID4: undefinedOrNull(form.getValues("nReplyID4"), "number"),
            nReplyID5: undefinedOrNull(form.getValues("nReplyID5"), "number"),
            nReplyID6: undefinedOrNull(form.getValues("nReplyID6"), "number"),
            nReplyID7: undefinedOrNull(form.getValues("nReplyID7"), "number"),
            nReplyID8: undefinedOrNull(form.getValues("nReplyID8"), "number"),
            nReplyID9: undefinedOrNull(form.getValues("nReplyID9"), "number"),
            nReplyID10: undefinedOrNull(form.getValues("nReplyID10"), "number"),
            nReplyID11: undefinedOrNull(form.getValues("nReplyID11"), "number"),
            nReplyID12: undefinedOrNull(form.getValues("nReplyID12"), "number"),
            nContagiousID9: undefinedOrNull(form.getValues("nContagiousID9"), "number"),
            sOther11: undefinedOrNull(form.getValues("sOther11"), "string"),
            sOther7: undefinedOrNull(form.getValues("sOther7"), "string"),
            sOther8: undefinedOrNull(form.getValues("sOther8"), "string"),
            sOther9: undefinedOrNull(form.getValues("sOther9"), "string"),
            sOther10: undefinedOrNull(form.getValues("sOther10"), "string"),
            nGestational12: undefinedOrNull(form.getValues("nGestational12"), "number"),
            lstFileUpLoad: arrFile || [],
            arrStudy: arrStudy || [],
            arrLanguageAbility: arrLanguageAbility || [],
            arrTWorkHistory: arrTWorkHistory || [],
            arrTrainingHistory: arrTrainingHistory || [],
            lstOptionReplyID1: form.getValues("lstOptionReplyID1") ? form.getValues("lstOptionReplyID1") : [],
            lstOptionReplyID3: form.getValues("lstOptionReplyID3") ? form.getValues("lstOptionReplyID3") : [],
        }
        console.log("lst", objData);
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmSave, () => {
            BlockUI();
            AxiosPost("UserRecruitment/onSaveData", objData, (res) => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.SaveComplete, () => {
                    //   window.location.reload();
                });
            }, null, null, null, () => {
                UnBlockUI();
            })
        });
    };

    return (
        <Grid container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
            <Grid container direction="row" xs={12} md={1.5} sx={{}} marginBottom={1} alignItems="start" justifyContent="center" style={{ marginTop: "10px" }}>
                <div className="uploadimg" style={{ backgroundImage: objFileImg?.sFileUrl ? "url(" + objFileImg?.sFileUrl + ")" : "" }} >
                    <div className="image-upload">
                        <input style={{ display: "none" }} type="file" id="onCameraFile" accept="image/*" onChange={_SendAPIFile} />
                        {objMasterData.isEditData && <div className="file-input" onClick={onUploadFile} >
                            <BsFillCameraFill />
                        </div>}
                    </div>
                </div>
            </Grid>
            <Grid item container direction="row" xs={12} md={10.5} sm={12} spacing={2}>
                <FormProvider {...form}>
                    <Grid item md={3} xs={12}>
                        <SelectFormItem disabled={!objMasterData.isEditData} options={objMasterData?.lstPosition || []} name={"nPositionID"} label={"ตำเหน่งงานที่สนใจ"} required />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <InputNumberForm name={"nSalary"} label={"เงินเดือนขั้นต่ำที่คาดหวัง"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <SelectFormItem options={objMasterData?.lstNewsSource || []} name={"nNewSourceID"} label={"แหล่งข่าวการสมัครงาน"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <SelectFormItem options={objMasterData?.lstRecruiting || []} name={"nRecruitmentID"} label={"ชื่อเจ้าหน้าที่สรรหา"} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sIDCard"} label={"เลขที่บัตรประชาชน"} maxLength={13} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <DatePickerFromItem
                            name={"dIDcardExpiration"}
                            label={"วันที่หมดอายุ"}
                            required
                            fullWidth
                            minDate={new Date()}
                            disabled={!objMasterData.isEditData}
                        />
                    </Grid>
                    <Grid item md={1.5} xs={12}>
                        <SelectFormItem options={objMasterData?.lstPrefixName || []} name={"nPrefixID"} label={"คำนำหน้า"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3.5} xs={12}>
                        <TextBoxForm name={"sFirstName_TH"} label={"ชื่อ (ไทย)"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <TextBoxForm name={"sLastName_TH"} label={"นามสกุล (ไทย)"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={5} xs={12}>
                        <TextBoxForm lang="en" name={"sFirstName_EN"} label={"ชื่อ (อังกฤษ)"} required isToUpperCase disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextBoxForm lang="en" name={"sLastName_EN"} label={"นามสกุล (อังกฤษ)"} required isToUpperCase disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <TextBoxForm name={"sNickname"} label={"ชื่อเล่น"} maxLength={50} required disabled={!objMasterData.isEditData} />
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item container direction="row" xs={12} md={12} sm={12} spacing={2} marginTop={0}>
                <FormProvider {...form}>
                    <Grid item md={1.6} xs={12}>
                        <DatePickerFromItem name={"dBirthday"} label={"วันเกิด"}
                            maxDate={Date()}
                            minDate={new Date(1960, 1, 1)}
                            required
                            onChange={(e) => {
                                if (e) {
                                    form.setValue("nAge", moment().year() - e.year());
                                }
                            }}
                            disabled={!objMasterData.isEditData}
                        />
                    </Grid>
                    <Grid item md={1.26} xs={12}>
                        <TextBoxForm name={"nAge"} label={"อายุ"} disabled />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <SelectFormItem options={objMasterData?.lstNationality || []} name={"nNationalityID"} label={"สัญชาติ"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3.5} xs={12}>
                        <SelectFormItem options={objMasterData?.lstNationality || []} name={"nEthnicityID"} label={"เชื้อชาติ"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2.62} xs={12}>
                        <SelectFormItem options={objMasterData?.lstReligion || []} name={"nReligionID"} label={"ศาสนา"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={1.56} xs={12}>
                        <SelectFormItem options={objMasterData?.lstSex || []} name={"nSexID"} label={"เพศ"} required onChange={(e) => {
                            if (e) {
                                setnSexID(undefinedOrNull(e.value, "number"));
                            } else {
                                setnSexID(null);
                            }
                        }} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={4.28} xs={12}>
                        <SelectFormItem options={objMasterData?.lstMaritalStatus || []} name={"nMaritalStatusID"} label={"สถานภาพสมรส"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"nWeight"} label={"น้ำหนัก"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={1.5} xs={12}>
                        <TextBoxForm name={"nHeight"} label={"ส่วนสูง"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    {nSexID === 15 && <Grid item md={2.65} xs={12}>
                        <SelectFormItem options={objMasterData?.lstMilitaryStatus || []} name={"nMilitaryStatusID"} label={"สถานภาพทางทหาร"} required disabled={!objMasterData.isEditData} />
                    </Grid>}
                    <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                        <Divider>ที่อยู่ตามทะเบียนบ้าน</Divider>
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextBoxForm name={"sVillage1"} label={"หมู่บ้าน/ตึก/ชั้น/ห้องที่"} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sHouseNumber1"} label={"เลขที"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"nMoo1"} label={"หมู่ที่"} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sChoi1"} label={"ชอย"} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sRoad1"} label={"ถนน"} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <SelectFormItem options={objMasterData?.lstProvince || []} name={"nProvince1ID"} label={"จังหวัด"} required disabled={!objMasterData.isEditData}
                            onChange={(val) => {
                                form.setValue("nDistrict1ID", null);
                                form.setValue("nSubDistrict1ID", null);
                                form.setValue("sZipCode1", null);
                                GetDistrictRegister(undefinedOrNull(val.value, "number"), 1);
                            }} />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <SelectFormItem options={arrDistrict1 || []} name={"nDistrict1ID"} label={"อำเภอ/เขต"} required disabled={!objMasterData.isEditData} onChange={(val) => {
                            form.setValue("nSubDistrict1ID", null);
                            form.setValue("sZipCode1", null);
                            GetTambonRegister(undefinedOrNull(val.value, "number"), 1);
                        }} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <SelectFormItem options={arrTambon1 || []} name={"nSubDistrict1ID"} label={"ตำบล/แขวง"} required disabled={!objMasterData.isEditData} onChange={(val) => {
                            form.setValue("sZipCode1", undefinedOrNull(val.valueOther, "string"));
                        }} />
                    </Grid>
                    <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                        <Divider>
                            <div style={{ display: "flex" }}><p style={{ marginRight: "10px", marginTop: "10px" }}>ที่อยู่ปัจจุบัน (ที่สามารถติดต่อได้)</p>
                                <CheckboxFormItem name="isSameAddress" label="ที่อยู่เดียวกับทะเบียนบ้าน" onChange={(e) => {
                                    if (e) {
                                        form.setValue("sVillage2", form.getValues("sVillage1"));
                                        form.setValue("sHouseNumber2", form.getValues("sHouseNumber1"));
                                        form.setValue("nMoo2", form.getValues("nMoo1"));
                                        form.setValue("sChoi2", form.getValues("sChoi1"));
                                        form.setValue("sRoad2", form.getValues("sRoad1"));
                                        form.setValue("nProvince2ID", form.getValues("nProvince1ID"));
                                        GetDistrictRegister(undefinedOrNull(form.getValues("nProvince1ID"), "number"), 2);
                                        form.setValue("nDistrict2ID", form.getValues("nDistrict1ID"));
                                        GetTambonRegister(undefinedOrNull(form.getValues("nDistrict1ID"), "number"), 2);
                                        form.setValue("nSubDistrict2ID", form.getValues("nSubDistrict1ID"));
                                        form.setValue("sZipCode2", form.getValues("sZipCode1"));
                                        form.clearErrors();
                                        setisSameAddress(true);

                                    } else {
                                        form.setValue("sVillage2", null);
                                        form.setValue("sHouseNumber2", null);
                                        form.setValue("nMoo2", null);
                                        form.setValue("sChoi2", null);
                                        form.setValue("sRoad2", null);
                                        form.setValue("nProvince2ID", null);
                                        form.setValue("nDistrict2ID", null);
                                        form.setValue("nSubDistrict2ID", null);
                                        form.setValue("sZipCode2", null);
                                        form.clearErrors();
                                        setisSameAddress(false);
                                    }
                                }} disabled={!objMasterData.isEditData} />
                            </div>
                        </Divider>
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextBoxForm name={"sVillage2"} label={"หมู่บ้าน/ตึก/ชั้น/ห้องที่"} disabled={isSameAddress || !objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sHouseNumber2"} label={"เลขที"} disabled={isSameAddress || !objMasterData.isEditData} required />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"nMoo2"} label={"หมู่ที่"} disabled={isSameAddress || !objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sChoi2"} label={"ชอย"} disabled={isSameAddress || !objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sRoad2"} label={"ถนน"} disabled={isSameAddress || !objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <SelectFormItem options={objMasterData?.lstProvince || []} name={"nProvince2ID"} label={"จังหวัด"} required
                            onChange={(val) => {
                                form.setValue("nDistrict2ID", null);
                                form.setValue("nSubDistrict2ID", null);
                                form.setValue("sZipCode2", null);
                                GetDistrictRegister(undefinedOrNull(val.value, "number"), 2);
                            }} disabled={isSameAddress || !objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <SelectFormItem options={arrDistrict2 || []} name={"nDistrict2ID"} label={"อำเภอ/เขต"} required
                            onChange={(val) => {
                                form.setValue("nSubDistrict2ID", null);
                                form.setValue("sZipCode2", null);
                                GetTambonRegister(undefinedOrNull(val.value, "number"), 2);
                            }} disabled={isSameAddress || !objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <SelectFormItem options={arrTambon2 || []} name={"nSubDistrict2ID"} label={"ตำบล/แขวง"} required
                            onChange={(val) => {
                                form.setValue("sZipCode2", undefinedOrNull(val.valueOther, "string"));
                            }} disabled={isSameAddress || !objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sZipCode2"} label={"รหัสไปรษณีย์"} required disabled={isSameAddress || !objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextBoxForm name={"sEmail"} label={"อีเมล์"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sIDLine"} label={"ID Line"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <TextBoxForm name={"sFacebook"} label={"Facebook"} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextBoxForm lang="number" name={"sMobileNumber"} label={"เบอร์มือถือ"} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <Divider>บุคคลที่ติดต่อกรณีเร่งด่วน</Divider>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <SelectFormItem options={objMasterData?.lstRelationship1 || []} name={"sRelationshipID"} label={"ความสัมพันธ์ "} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <TextBoxForm name={"sContactFName"} label={"ชื่อบิดา/มารดา/หรือญาติ"} required maxLength={250} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <TextBoxForm name={"sContactLName"} label={"นามสกุล"} required maxLength={150} disabled={!objMasterData.isEditData} />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <TextBoxForm lang="number" name={"sContactMobile"} label={"เบอร์มือถือ"} required maxLength={10} disabled={!objMasterData.isEditData} />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <TextBoxForm name={"sRelationship1"} label={"ความสัมพันธ์"} maxLength={250} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <TextBoxForm name={"sContactFName1"} label={"ชื่อบุคคลอื่นๆ"} maxLength={250} required disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <TextBoxForm name={"sContactLName1"} label={"นามสกุล"} maxLength={150} required disabled={!objMasterData.isEditData} />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <TextBoxForm lang="number" name={"sContactMobile1"} label={"เบอร์มือถือ"} maxLength={10} required disabled={!objMasterData.isEditData} />
                    </Grid>
                </FormProvider>
                <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                    <Divider><div style={{ display: "flex" }}><p style={{ marginTop: "10px" }}>ข้อมูลการประวัติการศึกษา</p><p style={{ fontSize: "12px", marginLeft: "5px", marginTop: "14px" }}> (เรียงจากปัจจุบันไปหาอดีต)</p></div></Divider>
                </Grid>
                <Grid item md={12} xs={12}>
                    <TableUI column={ColumnData || []}
                        row={arrStudy || []} />
                </Grid>
                <Grid item md={12} xs={12}>
                    {objMasterData.isEditData && <BtnAdd onClick={() => { setOpenPopupStudy(true) }} />}
                </Grid>
                <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                    <Divider>ความสามารถพิมพ์ดีด</Divider>
                </Grid>
                <FormProvider {...form}>
                    <Grid item md={6} xs={12}>
                        <InputNumberForm disabled={!objMasterData.isEditData} name={"nTypingAbility_TH"} label={"ไทย"} endAdornment={<div style={{ fontSize: "0.8em", width: "55px" }}>คำ/นาที</div>} required />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <InputNumberForm disabled={!objMasterData.isEditData} name={"nTypingAbility_EN"} label={"อังกฤษ"} endAdornment={<div style={{ fontSize: "0.8em", width: "55px" }}>คำ/นาที</div>} required />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <RadioForm disabled={!objMasterData.isEditData} name={"isInternet"} label={"Internet/Email"} options={[{ label: "ได้", value: "1" }, { label: "ไม่ได้", value: "0" }]} isShowRow required />
                    </Grid>
                </FormProvider>
                <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                    <Divider>ความสามารถด้านภาษา</Divider>
                </Grid>
                <Grid item md={12} xs={12}>
                    <TableUI column={ColumnLanguageAbilityData || []}
                        row={arrLanguageAbility || []} />
                </Grid>
                <Grid item md={12} xs={12}>
                    {objMasterData.isEditData && <BtnAdd onClick={() => { setOpenLanguage(true) }} />}
                </Grid>
                <FormProvider {...form}>
                    <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                        <CheckboxGroupFormItem label="โปรแกรมคอมพิวเตอร์ที่ใช้ได้" name={"arrComputerPrograml"} options={objMasterData.lstComputerPrograml || []} disabled={!objMasterData.isEditData} />
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <TextBoxForm name={"sOtherAbilities"} label={"ความสามารถอื่นๆ"} multiline rows={3} disabled={!objMasterData.isEditData} />
                    </Grid>
                </FormProvider>
                <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                    <Divider><div style={{ display: "flex" }}><p style={{ marginTop: "10px" }}>ประวัติการทำงาน</p></div></Divider>
                </Grid>
                <Grid item md={12} xs={12}>
                    <TableUI column={ColumnWorkHistorData || []}
                        row={arrTWorkHistory || []} />
                </Grid>
                <Grid item md={12} xs={12}>
                    {objMasterData.isEditData && <BtnAdd onClick={() => { setOpenWork(true) }} />}
                </Grid>

                <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                    <Divider>ประวัติการฝึกอบรม</Divider>
                </Grid>
                <Grid item md={12} xs={12}>
                    <TableUI column={ColumnDataTraining || []}
                        row={arrTrainingHistory || []} />
                </Grid>
                <Grid item md={12} xs={12}>
                    {objMasterData.isEditData && <BtnAdd onClick={() => { setOpenTraining(true) }} />}
                </Grid>
            </Grid>
            <Grid item container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
                <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                    <Divider>ข้อมูลส่วนตัวอื่นๆ เพิ่มเติม</Divider>
                </Grid>
                <FormProvider {...form}>
                    {(objMasterData.lstMQuestion || []).filter(f => nSexID === 15 ? f.nQuestionID != 12 : true).map(item => {
                        return <Grid item md={6} xs={12} marginTop={1}>
                            <div className="MainGroup">
                                <div className="divTitel">{item.nNo + " " + item.sQuestionName}</div>
                                <div className="divQBoby">
                                    <div className="divQitem">
                                        {(() => {
                                            switch (item.nQuestionID) {
                                                case 1: {
                                                    return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                                                        <Grid item md={12} xs={12}>
                                                            <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID1"} options={objMasterData.lstReply1 || []} isShowRow isNoLabel onChange={(e) => {
                                                                setnReplyID1(undefinedOrNull(e, "number"))
                                                            }} />
                                                        </Grid>
                                                        {nReplyID1 === 63 && <Grid item md={12} xs={12}>
                                                            <SelectMultipleFormItem disabled={!objMasterData.isEditData} options={objMasterData?.lstOptionReply1 || []} name={"lstOptionReplyID1"} label={"ประเภทรถยนต์"} required />
                                                        </Grid>}
                                                    </Grid>;
                                                };
                                                case 2: { return <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID2"} options={objMasterData.lstReply2 || []} isShowRow isNoLabel /> };
                                                case 3: {
                                                    return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                                                        <Grid item md={12} xs={12}>
                                                            <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID3"} options={objMasterData.lstReply3 || []} isShowRow isNoLabel onChange={(e) => {
                                                                setnReplyID3(undefinedOrNull(e, "number"))
                                                            }} />
                                                        </Grid>
                                                        {nReplyID3 === 67 && <Grid item md={12} xs={12}>
                                                            <SelectMultipleFormItem disabled={!objMasterData.isEditData} options={objMasterData?.lstOptionReply3 || []} name={"lstOptionReplyID3"} label={"ประเภทใบขับขี่"} required />
                                                        </Grid>}
                                                    </Grid>
                                                }
                                                case 4: { return <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID4"} options={objMasterData.lstReply4 || []} isShowRow isNoLabel /> }
                                                case 5: { return <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID5"} options={objMasterData.lstReply5 || []} isShowRow isNoLabel /> }
                                                case 6: { return <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID6"} options={objMasterData.lstReply6 || []} isShowRow isNoLabel /> }
                                                // case 7: { return <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID7"} options={objMasterData.lstReply7 || []} isShowRow isNoLabel /> }
                                                // case 8: { return <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID8"} options={objMasterData.lstReply8 || []} isShowRow isNoLabel /> }
                                                case 7: {
                                                    return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                                                        <Grid item md={12} xs={12}>
                                                            <RadioForm name={"nReplyID7"} options={objMasterData.lstReply7 || []} isShowRow isNoLabel onChange={(e) => {
                                                                setnReplyID7(undefinedOrNull(e, "number"))
                                                            }} />
                                                        </Grid>
                                                        {nReplyID7 === 75 && <Grid item md={12} xs={12}>
                                                            <TextBoxForm name={"sOther7"} label={"โทษคดี"} maxLength={450} />
                                                        </Grid>}
                                                    </Grid>
                                                }
                                                // case 8: { return <RadioForm name={"nReplyID8"} options={objMasterData.lstReply8 || []} isShowRow isNoLabel /> }
                                                case 8: {
                                                    return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                                                        <Grid item md={12} xs={12}>
                                                            <RadioForm name={"nReplyID8"} options={objMasterData.lstReply8 || []} isShowRow isNoLabel onChange={(e) => {
                                                                setnReplyID8(undefinedOrNull(e, "number"))
                                                            }} />
                                                        </Grid>
                                                        {nReplyID8 === 77 && <Grid item md={12} xs={12}>
                                                            <TextBoxForm name={"sOther8"} label={"สาเหตุ"} maxLength={450} />
                                                        </Grid>}
                                                    </Grid>
                                                }
                                                case 9: {
                                                    return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                                                        <Grid item md={12} xs={12}>
                                                            <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID9"} options={objMasterData.lstReply9 || []} isShowRow isNoLabel onChange={(e) => {
                                                                setnReplyID9(undefinedOrNull(e, "number"))
                                                            }} />
                                                        </Grid>
                                                        {nReplyID9 === 94 && <Grid item md={12} xs={12}>
                                                            <TextBoxForm disabled={!objMasterData.isEditData} name={"sOther9"} label={"โรคเรื้อรัง/โรคติดต่อร้ายแรง"} maxLength={450} required />
                                                        </Grid>}
                                                    </Grid>
                                                }
                                                case 10: {
                                                    return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                                                        <Grid item md={12} xs={12}>
                                                            <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID10"} options={objMasterData.lstReply10 || []} isShowRow isNoLabel
                                                                onChange={(e) => {
                                                                    setnReplyID10(undefinedOrNull(e, "number"))
                                                                }} />
                                                        </Grid>
                                                        {nReplyID10 == 80 && <Grid item md={12} xs={12}>
                                                            <TextBoxForm disabled={!objMasterData.isEditData} name={"sOther10"} label={"เพิ่มเติม"} maxLength={450} />
                                                        </Grid>}
                                                    </Grid>
                                                }
                                                case 11: {
                                                    return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                                                        <Grid item md={6} xs={12}>
                                                            <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID11"} options={objMasterData.lstReply11 || []} isShowRow isNoLabel onChange={(e) => {
                                                                setnReplyID11(undefinedOrNull(e, "number"))
                                                            }} />
                                                        </Grid>
                                                        {nReplyID11 == 81 && <Grid item md={12} xs={12}>
                                                            <TextBoxForm disabled={!objMasterData.isEditData} name={"sOther11"} label={"ชื่อหน่วยงานหรือบริษัท"} required maxLength={450} />
                                                        </Grid>
                                                        }
                                                    </Grid>
                                                }
                                                case 12: {
                                                    return <Grid container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                                                        <Grid item md={6} xs={12}>
                                                            <RadioForm disabled={!objMasterData.isEditData} name={"nReplyID12"} options={objMasterData.lstReply12 || []} isShowRow isNoLabel onChange={(e) => {
                                                                setnReplyID12(undefinedOrNull(e, "number"))
                                                            }} />

                                                        </Grid>
                                                        <Grid item md={2} xs={12}>
                                                            {nReplyID12 === 83 && <InputNumberForm disabled={!objMasterData.isEditData} name={"nGestational12"} label={"อายุครรภ์"} maxDigits={0} maxInteger={1} required />}
                                                        </Grid>
                                                    </Grid>
                                                }
                                            }
                                        })()}

                                    </div>
                                </div>
                            </div>
                        </Grid>
                    })}
                </FormProvider>
            </Grid>
            <Grid item container direction="row" xs={12} md={12} sx={{}} spacing={1} marginBottom={1}>
                <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                    <Divider>อัปโหลดไฟล์ เพิ่มเติม เช่น Resume เป็นต้น</Divider>
                </Grid>
                <Grid item md={12} xs={12}>
                    <TableUI column={ColumnDataFlle || []}
                        row={arrFile || []} />
                </Grid>
                <Grid item md={12} xs={12}>
                    <input style={{ display: "none" }} type="file" id="onCameraFileOthor" accept="image/*,application/pdf,application/vnd.ms-excel" onChange={_SendAPIFileOthor} />
                    {objMasterData.isEditData && <BtnAdd onClick={onUploadFileOthor} />}
                </Grid>
            </Grid>
            <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                <Divider></Divider>
            </Grid>
            <Grid item md={12} xs={12}>
                <p style={{ fontSize: "12px" }}>วันที่สมัคร : {objMasterData?.objData?.dRegister || " -"}</p>
                <p style={{ fontSize: "12px" }}>แก้ไขโดย : {objMasterData?.objData?.sUpdateby || " -"}</p>
                <p style={{ fontSize: "12px" }}>วันที่แก้ไข : {objMasterData?.objData?.dUpdate || " -"}</p>
            </Grid>
            <Grid item md={12} xs={12}>
                <Grid marginTop={0} md={12} container direction="row" alignItems="center" justifyContent="center" sx={{}}>
                    {objMasterData.isEditData && <BtnSaveIcon style={{ width: "130px", marginLeft: "10px" }} onClick={form.handleSubmit(() => { Savedata(); })} />}
                </Grid>
            </Grid>

            <Dialog
                maxWidth={"lg"}
                fullWidth={true}
                open={openPopupStudy}
                onClose={handleClosePopupStudy}
                disableEscapeKeyDown

                sx={{ borderRadius: "23px" }}
            >
                <DialogTitle style={{
                    borderBottom: "1px solid #FD8D14"
                }}><AiFillEdit /> รายละเอียดการศึกษา</DialogTitle>
                <DialogContent>
                    <FormProvider {...formStudy}>
                        <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
                            <Grid item md={4} xs={12}>
                                <SelectFormItem disabled={!objMasterData.isEditData} options={objMasterData.lstEducationLevel || []} name={"nEducationLevelID"} label={"ระดับการศึกษา"} required />
                            </Grid>
                            <Grid item md={8} xs={12}>
                                <TextBoxForm disabled={!objMasterData.isEditData} name={"sInstitution"} label={"สถาบัน"} required maxLength={250} />
                            </Grid>
                            <Grid item md={10} xs={12}>
                                <TextBoxForm disabled={!objMasterData.isEditData} name={"sBranch"} label={"สาขาวิชา "} required maxLength={250} />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                <InputNumberForm disabled={!objMasterData.isEditData} name={"nGPA"} label={"GPA"} required maxInteger={1} maxDigits={2} maxLength={4.00} />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <DatePickerFromItem disabled={!objMasterData.isEditData} name={"dAdmissionDate"} label={"วันที่เข้าศึกษา"}
                                    maxDate={dGraduationDate} required
                                    minDate={new Date(1955, 1, 1)}
                                    fullWidth
                                    onChange={(e) => {
                                        setdAdmissionDate(e);
                                        form.setValue("dGraduationDate", null);
                                    }}
                                />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <DatePickerFromItem disabled={!objMasterData.isEditData} name={"dGraduationDate"} label={"วันที่จบศึกษา"}
                                    maxDate={Date()}
                                    fullWidth
                                    onChange={(e) => setdGraduationDate(e)}
                                    minDate={dAdmissionDate} required />
                            </Grid>
                        </Grid>
                    </FormProvider>
                    {/* </Box> */}
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleClose}>Close</Button> */}
                    <BtnCancelIcon onClick={() => handleClosePopupStudy({}, "")} />
                    {objMasterData.isEditData && <BtnSaveIcon onClick={formStudy.handleSubmit(() => { onSaveStudy(); })} />}
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={"lg"}
                fullWidth={true}
                open={openLanguage}
                onClose={handleCloseLanguage}
                sx={{ borderRadius: "23px", zIndex: "1" }}
            >
                <DialogTitle style={{
                    borderBottom: "1px solid #FD8D14"
                }}><AiFillEdit /> ความสามารถด้านภาษา</DialogTitle>
                <DialogContent>
                    <FormProvider {...formLanguage}>
                        <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
                            <Grid item md={4} xs={12}>
                                <SelectFormItem options={objMasterData.lstLanguage || []} name={"nlanguageID"} label={"ภาษา "} required disabled={nLanguageEditID != null} />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <InputNumberForm name={"nToeic"} label={"Toeic score"} maxDigits={2} disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <InputNumberForm name={"nToefl"} label={"Toefl score"} maxDigits={2} disabled={!objMasterData.isEditData} />
                            </Grid>

                            <Grid item md={3} xs={12}>
                                <SelectFormItem options={objMasterData.lstSkillLevel || []} name={"nSpeakingID"} label={"การพูด"} required disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <SelectFormItem options={objMasterData.lstSkillLevel || []} name={"nReadingID"} label={"การอ่าน"} required disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <SelectFormItem options={objMasterData.lstSkillLevel || []} name={"nWritingID"} label={"การเขียน "} required disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <SelectFormItem options={objMasterData.lstSkillLevel || []} name={"nListenID"} label={"การฟัง"} required disabled={!objMasterData.isEditData} />
                            </Grid>
                        </Grid>
                    </FormProvider>
                    {/* </Box> */}
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleClose}>Close</Button> */}
                    <BtnCancelIcon onClick={() => handleCloseLanguage({}, "")} />
                    {objMasterData.isEditData && <BtnSaveIcon onClick={formLanguage.handleSubmit(() => { onSaveLanguage(); })} />}
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={"lg"}
                fullWidth={true}
                open={openWork}
                onClose={handleCloseWork}
                sx={{ borderRadius: "23px" }}
            >
                <DialogTitle style={{
                    borderBottom: "1px solid #FD8D14"
                }}><AiFillEdit /> ประวัติการทำงาน</DialogTitle>
                <DialogContent>
                    <FormProvider {...formWork}>
                        <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
                            <Grid item md={6} xs={12}>
                                <TextBoxForm name={"sCompanyName"} label={"ชื่อบริษัท"} required maxLength={250} disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextBoxForm name={"sPosition"} label={"ตำแหน่ง"} required maxLength={250} disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                <InputNumberForm name={"nSalary"} label={"เงินเดือน"} required maxDigits={2} disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <DatePickerFromItem name={"dStartDate"} label={"วันที่เข้าทำงาน"} disabled={!objMasterData.isEditData} fullWidth
                                    maxDate={dEndDateWrok}
                                    minDate={new Date(1955, 1, 1)} required
                                    onChange={(e) => {
                                        setdStartDateWrok(e)
                                        formWork.setValue("dEndDate", null);
                                    }}
                                />
                            </Grid>
                            <Grid item md={1.5} xs={12}>
                                <CheckboxFormItem name="isNow" label="ถึงปัจจุบัน" onChange={(e) => { setisNow(e) }} disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={4.5} xs={12}>
                                {!isNow && <DatePickerFromItem disabled={!objMasterData.isEditData} name={"dEndDate"} label={"วันที่ทำงานสุดท้าย"} fullWidth
                                    maxDate={Date()} required
                                    minDate={dStartDateWrok}
                                    onChange={(e) => {
                                        setdEndDateWrok(e)
                                    }}
                                />}
                            </Grid>

                            <Grid item md={6} xs={12}>
                                <TextBoxForm name={"sBehavior"} label={"ลักษณะการทำงาน"} multiline rows={4} required maxLength={1000} disabled={!objMasterData.isEditData} />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextBoxForm name={"sReasonForLeaving"} label={"สาเหตุที่ออก"} multiline rows={4} maxLength={1000} disabled={!objMasterData.isEditData} />
                            </Grid>
                        </Grid>
                    </FormProvider>
                    {/* </Box> */}
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleClose}>Close</Button> */}
                    <BtnCancelIcon onClick={() => handleCloseWork({}, "")} />
                    {objMasterData.isEditData && <BtnSaveIcon onClick={formWork.handleSubmit(() => { onSaveWork(); })} />}
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={"lg"}
                fullWidth={true}
                open={openTraining}
                onClose={handleCloseTraining}
                sx={{ borderRadius: "23px" }}
            >
                <DialogTitle style={{
                    borderBottom: "1px solid #FD8D14"
                }}><AiFillEdit /> ประวัติการฝึกอบรม</DialogTitle>
                <DialogContent>
                    <FormProvider {...formTraining}>
                        <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1} marginTop={1}>
                            <Grid item md={6} xs={12}>
                                <TextBoxForm disabled={!objMasterData.isEditData} name={"sCourseName"} label={"ชื่อหลักสูตร"} required maxLength={250} />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextBoxForm disabled={!objMasterData.isEditData} name={"sCompanyName"} label={"ชื่อบริษัท"} required maxLength={250} />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <DatePickerFromItem disabled={!objMasterData.isEditData} name={"dStartDate"} label={"วันที่เริ่ม"} required fullWidth
                                    maxDate={dEndDateCourse}
                                    minDate={new Date(1955, 1, 1)}
                                    onChange={(e) => {
                                        setdStartDateCourse(e)
                                        formTraining.setValue("dEndDate", null);
                                    }}
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <DatePickerFromItem disabled={!objMasterData.isEditData} name={"dEndDate"} label={"วันที่จบ"} required fullWidth
                                    maxDate={new Date()}
                                    minDate={dStartDateCourse}
                                    onChange={(e) => {
                                        setdEndDateCourse(e)
                                    }}
                                />
                            </Grid>

                            <Grid item md={12} xs={12}>
                                <TextBoxForm disabled={!objMasterData.isEditData} name={"sNatureTraining"} label={"ลักษณะการอบรม"} multiline rows={4} required maxLength={1000} />
                            </Grid>

                        </Grid>
                    </FormProvider>
                </DialogContent>
                <DialogActions>
                    <BtnCancelIcon onClick={() => handleCloseTraining({}, "")} />
                    {objMasterData.isEditData && <BtnSaveIcon onClick={formTraining.handleSubmit(() => { onSaveTraining(); })} />}
                </DialogActions>
            </Dialog>

        </Grid>);
};

export default UserRegisterForm;